import React from 'react'
import getBackgroundStyles from '../functions/getBackgroundStyles'

const TrailerItemImage = ({backgroundImage, isMobile}) => {
    if(backgroundImage) {
        const styles = getBackgroundStyles(backgroundImage, false, isMobile)

        return <div className="grid-image" style={styles} />

    } else {
        return <div className="grid-image no-image" />
    }
}

export default TrailerItemImage